import { formatDateTimeTz } from 'src/utils'
import { z } from 'zod'

export const zodDateString = z
  .string()
  .datetime({ offset: true })
  .transform(formatDateTimeTz)

export const ModelSchemaBase = {
  id: z.number(),
  created_at: zodDateString,
  updated_at: zodDateString,
}

export const ErrorResSchema = z.object({
  attr: z.string().nullish(),
  code: z.string(),
  detail: z.string(),
})

export type IErrorRes = z.infer<typeof ErrorResSchema>
